import { render, staticRenderFns } from "./PortalCredential.vue?vue&type=template&id=c38e6142&scoped=true&"
import script from "./PortalCredential.vue?vue&type=script&lang=js&"
export * from "./PortalCredential.vue?vue&type=script&lang=js&"
import style0 from "./PortalCredential.vue?vue&type=style&index=0&id=c38e6142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38e6142",
  null
  
)

export default component.exports